import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tab, Tabs } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ManualImportView from "../Import/ManualImportView";
import { OpenAISettings } from "../Integrations/OpenAISettings";
// Disabled to reduce the product surface. Every component and API endpoint below is intact —
// see docs/feature-disabling-audit.md for what each does and why it was switched off.
//
// Sales Nav Export was a read-only viewer over the legacy `Search` collection, which only the
// extension's standalone exporter writes to. Session-based Sales Navigator and Recruiter
// exports never appeared there — they land in a list and show up under Contacts. The legacy
// API and the extension path still work; only the viewer is hidden.
//
// ATS & CRM additionally needs its multi-tenancy bug fixed before it comes back.
// import ApiAccessView from "../ApiAccess/ApiAccessView";
// import { MergeIntegrationSettings } from "../Settings/MergeIntegrationSettings";
// import SalesNavExportView from "../SalesNavExport/SalesNavExportView";
// To restore a disabled tab, re-add its entry to all three structures below and uncomment
// its import. The indices must stay contiguous and the two maps must stay mirror images.
const subTabToIndex = {
    import: 0,
    openai: 1,
    // "sales-nav-export": disabled
    // "api-access": disabled
    // "ats-crm": disabled
};
const indexToSubTab = {
    0: "import",
    1: "openai",
};
const tabs = [
    { label: "Import Data", component: _jsx(ManualImportView, {}) },
    { label: "OpenAI", component: _jsx(OpenAISettings, {}) },
    // { label: "Sales Nav Export", component: <SalesNavExportView /> },
    // { label: "API Access", component: <ApiAccessView /> },
    // { label: "ATS & CRM", component: <MergeIntegrationSettings /> },
];
const DataIntegrationsView = () => {
    var _a;
    const { subTab } = useParams();
    const navigate = useNavigate();
    const activeTab = subTab && subTabToIndex[subTab] !== undefined ? subTabToIndex[subTab] : 0;
    const handleTabChange = (_event, newValue) => {
        navigate(`/data-integrations/${indexToSubTab[newValue]}`);
    };
    return (_jsxs(Box, Object.assign({ sx: { height: "100%", display: "flex", flexDirection: "column" } }, { children: [_jsx(Box, Object.assign({ sx: { borderBottom: 1, borderColor: "divider", mb: 3 } }, { children: _jsx(Tabs, Object.assign({ value: activeTab, onChange: handleTabChange, variant: "scrollable", scrollButtons: "auto" }, { children: tabs.map((tab) => (_jsx(Tab, { label: tab.label }, tab.label))) })) })), _jsx(Box, Object.assign({ sx: { flex: 1, overflow: "auto" } }, { children: (_a = tabs[activeTab]) === null || _a === void 0 ? void 0 : _a.component }))] })));
};
export default DataIntegrationsView;
